<template>
    <div class="col-md-6">
        <div class="panel panel-default">
            <div class="panel-heading">
                {{trans_heading}} ({{trans_total}}: {{sum}})
                <select name="workTimeWeekDay" id="workTimeWeekDay" class="pull-right" v-model="selectedWeek">
                    <option :value="week" v-for="(week, index) in weeks">{{week}}</option>
                </select>
            </div>
            <div class="panel-body">
                <plot :id="plotId" :ref="plotId" :options="options" :type="type"></plot>
            </div>
        </div>
    </div>
</template>

<script>
  import axios from 'axios';
  import Plot from './Plot';

  export default {
    components: {'Plot': Plot},
    data() {
      return {
        trans_heading: Worklog.workTimeWeekDay.trans_heading,
        trans_total  : Worklog.workTimeWeekDay.trans_total,
        weeks        : Worklog.workTimeWeekDay.weeks,
        selectedWeek : Worklog.workTimeWeekDay.week,
        url          : Worklog.workTimeWeekDay.url,
        sum          : '',
        plotId       : 'workTimeWeekDayChart',
        type         : 'bar',
        options      : {
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true
                }
              }
            ]
          },
          legend: {
            display: false
          }
        },
      }
    },
    watch     : {
      selectedWeek: function (val) {
        this.fetchData();
      },
    },
    mounted() {
      this.sum = Worklog.workTimeWeekDay.data.sum;
      this.$refs[ this.plotId ].updateChart(Worklog.workTimeWeekDay.data.data);
    },
    methods   : {
      fetchData() {
        axios.get(this.url.replace(':week', this.selectedWeek))
          .then(response => {
            response.data && response.data.data && this.$refs[ this.plotId ].updateChart(response.data.data);
            response.data && (this.sum = response.data.sum);
          })
          .catch(e => {
            this.$refs[ this.plotId ].updateChart({
              dataSets: [],
              labels  : []
            });
          })
      }
    }
  }
</script>
